import styles from './BrainDestination.module.scss'
import {
  Link, useParams
} from "react-router-dom";
import { BiSupport } from "react-icons/bi";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { AiOutlineSend } from "react-icons/ai";
import { RiArrowGoBackFill } from "react-icons/ri";
import { AuthContext } from '../../contexts/AuthContext';
import bg_box from '../../images/bg_box.png'
import bg_main from '../../images/bg_logado.png'
import { useContext, useEffect, useState, useRef } from 'react';
import bgchat from '../../images/bg_chat.png'
import api from '../../services/api'
import moment from 'moment/moment';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom'
import { ImSad } from "react-icons/im";


function BrainDestination() {
  const navigate = useNavigate();
  const [chatFiles, setChatFiles] = useState([]);
  const [chat, setChat] = useState([]);
  const { id } = useParams();
  const [message, setMessage] = useState('');
  const { user, getToken } = useContext(AuthContext);
  const chatScroll = useRef(null);
  const [isActive, setIsActive] = useState(true);
  const [loading, setLoading] = useState(true);
  const [loadingChat, setLoadingChat] = useState(false);
  const [faqs, setFaqs] = useState([])
  const [faqsHistory, setFaqsHistory] = useState([])
  const [destinationInfo, setDestinationInfo] = useState({});
  const [showDestino, setShowDestino] = useState(false);

  useEffect(() => {
    setLoading(true);
    getDestinationInfo()
  }, [])

  useEffect(() => {
    scrollDown();
  }, [chat]);

  async function getDestinationInfo(){
      await api.post('/destinationinfo')
      .then(res => {
        if(res.data.retorno.temdestino) {
          setShowDestino(true);
          setDestinationInfo(res.data.retorno);
          iniciarConversa();
        }
        console.log(destinationInfo);
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        setLoading(false);
      })
  }

  function iniciarConversa(){
    setLoadingChat(true)
    api.post('/destinationinit')
    .then((res) => {
      const ret = {
          dono: false,
          nome: 'Cibele',
          mensagem: res.data.retorno.mensagem
        };

        setFaqs(res.data.retorno.faqs);
        setFaqsHistory(prevHistory => [...prevHistory, res.data.retorno.faqs]);
        setChat(prevChat => [...prevChat, ret]);
    }).catch(err => {
      console.log(err);
    })
    setLoadingChat(false);
  }

  const scrollDown = () => {
    if (chatScroll.current) {
      chatScroll.current.scrollTop = chatScroll.current.scrollHeight;
    }
  };

  function handleMessageChange(e) {
    setMessage(e.target.value);
  }

  function sendMessage() {
    console.log(message, 'enviando');
    if (message === '') {
      return;
    }


    setLoadingChat(true);

    setChat(prevChat => [
        ...prevChat,
        {
          dono: true,
          nome: user.nome,
          mensagem: message
        }
    ]);

    setMessage('');

    api.post('/askdestination/', { message, historyconversation: chat, historyfaqs: faqsHistory })
      .then(res => {
        const ret = {
          dono: false,
          nome: 'Cibele',
          mensagem: res.data.retorno.mensagem
        };

        setFaqs(res.data.retorno.faqs);
        setFaqsHistory(prevHistory => [...prevHistory, res.data.retorno.faqs]);
        setChat(prevChat => [...prevChat, ret]);

        setLoading(false);
      })
      .catch(err => {
        console.log(err);
        setLoading(false);
      })
      .finally(() => {
        setLoadingChat(false)
        scrollDown();
      })
  }

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); 
      sendMessage();
    }
  };



  const bgStyleBox = {
    backgroundImage: `url(${bg_box})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    overflow: 'hidden',
  };

  const bgMain = {
    backgroundImage: `url(${bg_main})`,
        backgroundSize: 'cover',
    backgroundPosition: 'center',
    overflow: 'hidden'
  };
  const bgChatStyle = {
    backgroundImage: `url(${bgchat})`,
    backgroundPosition: 'center',
    overflow: 'hidden'
  };

  let dayArr = {};

  return (
    <>
      {loading ? <div className={styles.loadingChat}><AiOutlineLoading3Quarters /></div> :
        <>
          <div className={styles.bg} style={bgMain}>
            <div>
              <h1>{showDestino ? 'Meu destino' : 
              <>
              <div style={{display:"flex", flexDirection: "column", alignItems: "center"}}>
              <ImSad />Você ainda não tem um destino programado!
              <button onClick={() => navigate(-1)}>Voltar <RiArrowGoBackFill /></button>
              </div>
              </>
              }
              </h1>
            </div>
          </div>

          <div className={styles.container}>     
            {showDestino ?        
            <div className={styles.cards}>
              <div style={bgStyleBox}> 
                <h6>Clima</h6>
                  <p> { destinationInfo?.clima } </p>
              </div>
              <div style={bgStyleBox}>
                <h6>Diferenciais</h6>
                  <p> { destinationInfo?.diferenciais } </p>
              </div>
              <div style={bgStyleBox}>
                <h6>Atrações turísticas</h6>
                  <p> { destinationInfo?.atracoes} </p>
              </div>
              <div style={bgStyleBox}>
                <h6>Curiosidades</h6>
                  <p> { destinationInfo?.outros } </p>
              </div>
            </div>
            : ''}
          </div>

          <div className={styles.container}>
            {showDestino ? 
            <>
              <div className={styles.headerList}>
                <h2><span>Tire todas as suas dúvidas sobre o seu destino!</span></h2>
                <button onClick={() => navigate(-1)}><RiArrowGoBackFill /></button>
              </div>

           

              <div className={styles.chat} style={bgChatStyle}>

                {/* <div className={styles.faqsList}>        
                  { loadingChat ? <div className={styles.loadingChat}><AiOutlineLoading3Quarters/></div> :
                  <>
                  {faqs.length > 0 && faqs.map(q => (
                    <div key={q.faqId}>
                      <span><b>{q.faqId}-{q.pergunta}</b></span>
                      <span dangerouslySetInnerHTML={{__html: q.resposta}} />
                    </div>
                  ))}       
                  </> }
                </div> */}

                <div className={styles.chatWrapper}>

                  <div ref={chatScroll} className={styles.chatArea}>

                    <>
                      {chat.map(c => {
                        return <>
                          {c.dono === true ?
                            <div className={`${styles.messageUser} ${styles.message}`}>
                              <span dangerouslySetInnerHTML={{ __html: c.mensagem }} />
                              {/* <span className={styles.timestamp}>{currentTimeFormatted.format('HH:mm')}</span> */}
                            </div>
                            :
                            <div className={`${styles.messageAdmin} ${styles.message}`}>
                              <span className={styles.nome}>{c.nome}</span>
                              <span dangerouslySetInnerHTML={{ __html: c.mensagem }} />
                              {/* <span className={styles.timestamp}>{currentTimeFormatted.format('HH:mm')}</span> */}
                            </div>
                          }
                        </>
                      })
                      }

                    </>

                  </div>
                  {isActive ?                    
                      <div className={styles.inputMessage}>
                        <textarea onKeyDown={handleKeyDown} value={message} onChange={handleMessageChange} placeholder='Escreva sua mensagem'></textarea>
                        <div className={styles.inputButton}>
                           { loadingChat ? <div className={styles.loadingChat}><AiOutlineLoading3Quarters/></div> :
                            <>
                            <button className={styles.buttonMessage} onClick={sendMessage}><AiOutlineSend /></button>
                            </>                            
                           }                          
                         </div>
                      </div>
                    :
                    <div></div>
                  }        
                </div>
              </div>

            </> :
            ''}

          </div>
        </>
      }
    </>
  );
}

export default BrainDestination;
